import { memo } from 'react'

export default memo(function Relatorio(props: any) {
  return (
    <svg
      width={props.size || '48px'}
      height={props.size || '48px'}
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.799951 19.6002H15.2C15.55 19.6002 15.7999 19.3502 15.7999 19.0002V5.2002C15.7999 5.0502 15.75 4.9002 15.65 4.8002L12.0499 0.650195C11.95 0.550195 11.8 0.450195 11.6 0.450195H0.799951C0.499952 0.450195 0.199951 0.700195 0.199951 1.0502V19.0002C0.199951 19.3002 0.449952 19.6002 0.799951 19.6002ZM14.5499 18.3502H1.39995V1.7002H11.3L14.5499 5.4502V18.3502ZM4.39996 8.2502H11.6C11.95 8.2502 12.2 7.95019 12.2 7.65019C12.2 7.35019 11.95 7.05019 11.6 7.05019H4.39996C4.09996 7.05019 3.79996 7.35019 3.79996 7.65019C3.79996 7.95019 4.04996 8.2502 4.39996 8.2502ZM11.6 11.8502H4.39996C4.04996 11.8502 3.79996 11.5502 3.79996 11.2502C3.79996 10.9502 4.09996 10.6502 4.39996 10.6502H11.6C11.95 10.6502 12.2 10.9502 12.2 11.2502C12.2 11.5502 11.95 11.8502 11.6 11.8502ZM4.39996 15.4002H11.6C11.95 15.4002 12.2 15.1002 12.2 14.8002C12.2 14.5002 11.95 14.2002 11.6 14.2002H4.39996C4.09996 14.2002 3.79996 14.5002 3.79996 14.8002C3.79996 15.1002 4.04996 15.4002 4.39996 15.4002Z"
        fill={props.color ? props.color : '#888'}
      />
    </svg>
  )
})
